import React, {Component} from 'react'

import { FILE_STORAGE } from '../../../constants'

// import components
import Gallery from '../Gallery'
import OtherFileList from '../OtherFileList'

// import styles
import './fileArea.scss'

class FileArea extends Component {
  // Render image
  renderImage (image, index) {
    let url = FILE_STORAGE + image.ThumbURL
    let fullUrl = FILE_STORAGE + image.FileURL
    return (
      <div key={index} className='file-image'>
        <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
      </div>
    )
  }

  render () {
    return (
      <div>
        {(this.props.showFiles === undefined || this.props.showFiles === true) && (
          <OtherFileList
            files={this.props.otherFiles}
            showDelete={this.props.showDelete}
            auth={this.props.auth} />
        )}
        {(this.props.showImages === undefined || this.props.showImages === true) && (
          <Gallery files={this.props.images} renderImage={this.renderImage} />
        )}
      </div>
    )
  }
}

export default FileArea



// WEBPACK FOOTER //
// ./src/app/shared/components/FileArea/index.js